{
  "api/v1/customer/calendar-view": {
    "days": [
      {
        "date": "DATE(0,MED)",
        "jobs": [
          {
            "id": 90001,
            "date": "DATE(0,MED)",
            "address_id": "ADDRESS_ID_1",
            "service_name": "4 hour cleaning",
            "original_service_name": "4 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "11:30",
            "timezone": "ADDRESS_TZ_1",
            "is_private": true,
            "job_progress": "in_progress",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91001,
              "start_date_no_earlier_than": "DATE(0,SLASH)",
              "start_time_no_earlier_than": "11:30am",
              "end_date_no_later_than": "DATE(0,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92001,
                "homekeeper": {
                  "id": 94001,
                  "name": "Maria Lopez"
                }
              }
            ]
          },
          {
            "id": 90002,
            "date": "DATE(0,MED)",
            "address_id": "ADDRESS_ID_2",
            "service_name": "3 hour cleaning",
            "original_service_name": "3 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "08:00",
            "timezone": "ADDRESS_TZ_2",
            "is_private": true,
            "job_progress": "completed",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91002,
              "start_date_no_earlier_than": "DATE(0,SLASH)",
              "start_time_no_earlier_than": "8:00am",
              "end_date_no_later_than": "DATE(0,SLASH)",
              "end_time_no_later_than": "11:00am"
            },
            "homekeeper_jobs": [
              {
                "id": 92002,
                "homekeeper": {
                  "id": 94002,
                  "name": "Blueline Enterprises"
                }
              }
            ]
          },
          {
            "id": 90003,
            "date": "DATE(0,MED)",
            "address_id": "ADDRESS_ID_3",
            "service_name": "2.5 hour cleaning",
            "original_service_name": "2.5 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "10:00",
            "timezone": "ADDRESS_TZ_3",
            "is_private": true,
            "job_progress": "homekeeper_call_out",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91003,
              "start_date_no_earlier_than": "DATE(0,SLASH)",
              "start_time_no_earlier_than": "10:00am",
              "end_date_no_later_than": "DATE(0,SLASH)",
              "end_time_no_later_than": "12:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92003,
                "homekeeper": {
                  "id": 94003,
                  "name": "Jake Turner"
                }
              }
            ]
          },
          {
            "id": 90004,
            "date": "DATE(0,MED)",
            "address_id": "ADDRESS_ID_3",
            "service_name": "2.5 hour cleaning",
            "original_service_name": "2.5 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "13:00",
            "timezone": "ADDRESS_TZ_3",
            "is_private": true,
            "job_progress": "substitute_requested",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91004,
              "start_date_no_earlier_than": "DATE(0,SLASH)",
              "start_time_no_earlier_than": "1:00pm",
              "end_date_no_later_than": "DATE(0,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": []
          },
          {
            "id": 90005,
            "date": "DATE(0,MED)",
            "address_id": "ADDRESS_ID_4",
            "service_name": "Trash Out",
            "original_service_name": "Trash Out",
            "service_category_id": 108,
            "service_category": "trash_service",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service_map.svg",
            "start_time": "11:00",
            "timezone": "ADDRESS_TZ_4",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91005,
              "start_date_no_earlier_than": "DATE(0,SLASH)",
              "start_time_no_earlier_than": "11:00am",
              "end_date_no_later_than": "DATE(0,SLASH)",
              "end_time_no_later_than": "11:30am"
            },
            "homekeeper_jobs": [
              {
                "id": 92005,
                "homekeeper": {
                  "id": 94006,
                  "name": "Tom Nguyen"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93001,
            "address_id": "ADDRESS_ID_1",
            "check_in_date": "DATE(-3,MED)",
            "check_out_date": "DATE(0,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_1",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMKTXR8P2A",
              "guest": {
                "first_name": "Sarah",
                "profile_picture": "https://randomuser.me/api/portraits/women/68.jpg",
                "last_name": "Chen"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93003,
            "address_id": "ADDRESS_ID_5",
            "check_in_date": "DATE(-2,MED)",
            "check_out_date": "DATE(2,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_5",
            "total_pets": 1,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 1,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMQW93JF7B",
              "guest": {
                "first_name": "Emily",
                "profile_picture": "https://randomuser.me/api/portraits/women/44.jpg",
                "last_name": "Rodriguez"
              }
            }
          },
          {
            "id": 93004,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(-4,MED)",
            "check_out_date": "DATE(1,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 3,
            "total_guests": 3,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 3,
              "total_guests": 3,
              "total_children": 0
            },
            "source_data": {
              "platform": "Booking.com",
              "code": "BK20847715",
              "guest": {
                "first_name": "James",
                "profile_picture": "https://randomuser.me/api/portraits/men/75.jpg",
                "last_name": "Wilson"
              }
            }
          }
        ],
        "inquiries": [],
        "availability_requests": []
      },
      {
        "date": "DATE(1,MED)",
        "jobs": [
          {
            "id": 90006,
            "date": "DATE(1,MED)",
            "address_id": "ADDRESS_ID_6",
            "service_name": "4 hour cleaning",
            "original_service_name": "4 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "11:30",
            "timezone": "ADDRESS_TZ_6",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91006,
              "start_date_no_earlier_than": "DATE(1,SLASH)",
              "start_time_no_earlier_than": "11:30am",
              "end_date_no_later_than": "DATE(1,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92006,
                "homekeeper": {
                  "id": 94001,
                  "name": "Maria Lopez"
                }
              }
            ]
          },
          {
            "id": 90007,
            "date": "DATE(1,MED)",
            "address_id": "ADDRESS_ID_7",
            "service_name": "Inspection",
            "original_service_name": "Inspection",
            "service_category_id": 11,
            "service_category": "inspection",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/inspection.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/inspection_map.svg",
            "start_time": "13:00",
            "timezone": "ADDRESS_TZ_7",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91007,
              "start_date_no_earlier_than": "DATE(1,SLASH)",
              "start_time_no_earlier_than": "1:00pm",
              "end_date_no_later_than": "DATE(1,SLASH)",
              "end_time_no_later_than": "2:00pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92007,
                "homekeeper": {
                  "id": 94004,
                  "name": "Premier Property Care"
                }
              }
            ]
          },
          {
            "id": 90008,
            "date": "DATE(1,MED)",
            "address_id": "ADDRESS_ID_8",
            "service_name": "Handyman",
            "original_service_name": "Handyman",
            "service_category_id": 13,
            "service_category": "handyman",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/handyman.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/handyman_map.svg",
            "start_time": "11:00",
            "timezone": "ADDRESS_TZ_8",
            "is_private": true,
            "job_progress": "request_waiting_reply",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": true,
            "booking": {
              "id": 91008,
              "start_date_no_earlier_than": "DATE(1,SLASH)",
              "start_time_no_earlier_than": "11:00am",
              "end_date_no_later_than": "DATE(3,SLASH)",
              "end_time_no_later_than": "3:00pm"
            },
            "homekeeper_jobs": []
          }
        ],
        "reservations": [
          {
            "id": 93004,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(-4,MED)",
            "check_out_date": "DATE(1,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 3,
            "total_guests": 3,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 3,
              "total_guests": 3,
              "total_children": 0
            },
            "source_data": {
              "platform": "Booking.com",
              "code": "BK20847715",
              "guest": {
                "first_name": "James",
                "profile_picture": "https://randomuser.me/api/portraits/men/75.jpg",
                "last_name": "Wilson"
              }
            }
          },
          {
            "id": 93005,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(1,MED)",
            "check_out_date": "DATE(5,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMZN51VK9C",
              "guest": {
                "first_name": "Anna",
                "profile_picture": "https://randomuser.me/api/portraits/women/65.jpg",
                "last_name": "Kowalski"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93003,
            "address_id": "ADDRESS_ID_5",
            "check_in_date": "DATE(-2,MED)",
            "check_out_date": "DATE(2,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_5",
            "total_pets": 1,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 1,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMQW93JF7B",
              "guest": {
                "first_name": "Emily",
                "profile_picture": "https://randomuser.me/api/portraits/women/44.jpg",
                "last_name": "Rodriguez"
              }
            }
          }
        ],
        "inquiries": [],
        "availability_requests": []
      },
      {
        "date": "DATE(2,MED)",
        "jobs": [
          {
            "id": 90009,
            "date": "DATE(2,MED)",
            "address_id": "ADDRESS_ID_5",
            "service_name": "4 hour cleaning",
            "original_service_name": "4 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "11:30",
            "timezone": "ADDRESS_TZ_5",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91009,
              "start_date_no_earlier_than": "DATE(2,SLASH)",
              "start_time_no_earlier_than": "11:30am",
              "end_date_no_later_than": "DATE(2,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92009,
                "homekeeper": {
                  "id": 94005,
                  "name": "Sparkle Cleaning Co"
                }
              }
            ]
          },
          {
            "id": 90010,
            "date": "DATE(2,MED)",
            "address_id": "ADDRESS_ID_3",
            "service_name": "2.5 hour cleaning",
            "original_service_name": "2.5 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "10:00",
            "timezone": "ADDRESS_TZ_3",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91010,
              "start_date_no_earlier_than": "DATE(2,SLASH)",
              "start_time_no_earlier_than": "10:00am",
              "end_date_no_later_than": "DATE(2,SLASH)",
              "end_time_no_later_than": "12:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92010,
                "homekeeper": {
                  "id": 94004,
                  "name": "Premier Property Care"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93003,
            "address_id": "ADDRESS_ID_5",
            "check_in_date": "DATE(-2,MED)",
            "check_out_date": "DATE(2,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_5",
            "total_pets": 1,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 1,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMQW93JF7B",
              "guest": {
                "first_name": "Emily",
                "profile_picture": "https://randomuser.me/api/portraits/women/44.jpg",
                "last_name": "Rodriguez"
              }
            }
          },
          {
            "id": 93006,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(2,MED)",
            "check_out_date": "DATE(4,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 4,
            "total_guests": 4,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 4,
              "total_guests": 4,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMPL26XD4E",
              "guest": {
                "first_name": "Carlos",
                "profile_picture": "https://randomuser.me/api/portraits/men/5.jpg",
                "last_name": "Mendez"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93005,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(1,MED)",
            "check_out_date": "DATE(5,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMZN51VK9C",
              "guest": {
                "first_name": "Anna",
                "profile_picture": "https://randomuser.me/api/portraits/women/65.jpg",
                "last_name": "Kowalski"
              }
            }
          }
        ],
        "inquiries": [
          {
            "id": 96001,
            "uuid": "demo-inquiry-96001",
            "address_id": "ADDRESS_ID_1",
            "status": "pending",
            "check_in_date": "DATE(2,MED)",
            "check_out_date": "DATE(4,MED)",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_1",
            "guest_name": "Lauren Mitchell",
            "total_adults": 2,
            "total_children": 1,
            "total_infants": 0,
            "total_pets": 0,
            "total_guests": 3,
            "source_type_name": "Airbnb",
            "source_logo_url": "https://retool-uploads.s3.us-west-2.amazonaws.com/integrations/Airbnblogo.svg",
            "nights": 2,
            "currency": "USD",
            "amount": 59655,
            "source_data": {
              "platform": "Airbnb",
              "guest": {
                "first_name": "Lauren",
                "last_name": "Mitchell",
                "profile_picture": "https://randomuser.me/api/portraits/women/33.jpg"
              }
            }
          }
        ],
        "availability_requests": []
      },
      {
        "date": "DATE(3,MED)",
        "jobs": [
          {
            "id": 90011,
            "date": "DATE(3,MED)",
            "address_id": "ADDRESS_ID_10",
            "service_name": "5 hour cleaning",
            "original_service_name": "5 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "10:00",
            "timezone": "ADDRESS_TZ_10",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91011,
              "start_date_no_earlier_than": "DATE(3,SLASH)",
              "start_time_no_earlier_than": "10:00am",
              "end_date_no_later_than": "DATE(3,SLASH)",
              "end_time_no_later_than": "3:00pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92011,
                "homekeeper": {
                  "id": 94005,
                  "name": "Sparkle Cleaning Co"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93006,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(2,MED)",
            "check_out_date": "DATE(4,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 4,
            "total_guests": 4,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 4,
              "total_guests": 4,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMPL26XD4E",
              "guest": {
                "first_name": "Carlos",
                "profile_picture": "https://randomuser.me/api/portraits/men/5.jpg",
                "last_name": "Mendez"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93005,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(1,MED)",
            "check_out_date": "DATE(5,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMZN51VK9C",
              "guest": {
                "first_name": "Anna",
                "profile_picture": "https://randomuser.me/api/portraits/women/65.jpg",
                "last_name": "Kowalski"
              }
            }
          }
        ],
        "inquiries": [
          {
            "id": 96002,
            "uuid": "demo-inquiry-96002",
            "address_id": "ADDRESS_ID_3",
            "status": "pending",
            "check_in_date": "DATE(3,MED)",
            "check_out_date": "DATE(6,MED)",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_3",
            "guest_name": "Priya Shah",
            "total_adults": 2,
            "total_children": 0,
            "total_infants": 0,
            "total_pets": 0,
            "total_guests": 2,
            "source_type_name": "Airbnb",
            "source_logo_url": "https://retool-uploads.s3.us-west-2.amazonaws.com/integrations/Airbnblogo.svg",
            "nights": 3,
            "currency": "USD",
            "amount": 65669,
            "source_data": {
              "platform": "Airbnb",
              "guest": {
                "first_name": "Priya",
                "last_name": "Shah",
                "profile_picture": "https://randomuser.me/api/portraits/women/26.jpg"
              }
            }
          }
        ],
        "availability_requests": []
      },
      {
        "date": "DATE(4,MED)",
        "jobs": [
          {
            "id": 90012,
            "date": "DATE(4,MED)",
            "address_id": "ADDRESS_ID_9",
            "service_name": "4 hour cleaning",
            "original_service_name": "4 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "11:30",
            "timezone": "ADDRESS_TZ_9",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91012,
              "start_date_no_earlier_than": "DATE(4,SLASH)",
              "start_time_no_earlier_than": "11:30am",
              "end_date_no_later_than": "DATE(4,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92012,
                "homekeeper": {
                  "id": 94002,
                  "name": "Blueline Enterprises"
                }
              }
            ]
          },
          {
            "id": 90013,
            "date": "DATE(4,MED)",
            "address_id": "ADDRESS_ID_4",
            "service_name": "Trash In",
            "original_service_name": "Trash In",
            "service_category_id": 108,
            "service_category": "trash_service",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service_map.svg",
            "start_time": "11:00",
            "timezone": "ADDRESS_TZ_4",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91013,
              "start_date_no_earlier_than": "DATE(4,SLASH)",
              "start_time_no_earlier_than": "11:00am",
              "end_date_no_later_than": "DATE(4,SLASH)",
              "end_time_no_later_than": "11:30am"
            },
            "homekeeper_jobs": [
              {
                "id": 92013,
                "homekeeper": {
                  "id": 94006,
                  "name": "Tom Nguyen"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93006,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(2,MED)",
            "check_out_date": "DATE(4,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 4,
            "total_guests": 4,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 4,
              "total_guests": 4,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMPL26XD4E",
              "guest": {
                "first_name": "Carlos",
                "profile_picture": "https://randomuser.me/api/portraits/men/5.jpg",
                "last_name": "Mendez"
              }
            }
          },
          {
            "id": 93007,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(4,MED)",
            "check_out_date": "DATE(7,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR5193804",
              "guest": {
                "first_name": "Rachel",
                "profile_picture": "https://randomuser.me/api/portraits/women/79.jpg",
                "last_name": "Kim"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93005,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(1,MED)",
            "check_out_date": "DATE(5,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMZN51VK9C",
              "guest": {
                "first_name": "Anna",
                "profile_picture": "https://randomuser.me/api/portraits/women/65.jpg",
                "last_name": "Kowalski"
              }
            }
          }
        ],
        "inquiries": [
          {
            "id": 96001,
            "uuid": "demo-inquiry-96001",
            "address_id": "ADDRESS_ID_1",
            "status": "pending",
            "check_in_date": "DATE(2,MED)",
            "check_out_date": "DATE(4,MED)",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_1",
            "guest_name": "Lauren Mitchell",
            "total_adults": 2,
            "total_children": 1,
            "total_infants": 0,
            "total_pets": 0,
            "total_guests": 3,
            "source_type_name": "Airbnb",
            "source_logo_url": "https://retool-uploads.s3.us-west-2.amazonaws.com/integrations/Airbnblogo.svg",
            "nights": 2,
            "currency": "USD",
            "amount": 59655,
            "source_data": {
              "platform": "Airbnb",
              "guest": {
                "first_name": "Lauren",
                "last_name": "Mitchell",
                "profile_picture": "https://randomuser.me/api/portraits/women/33.jpg"
              }
            }
          }
        ],
        "availability_requests": []
      },
      {
        "date": "DATE(5,MED)",
        "jobs": [
          {
            "id": 90014,
            "date": "DATE(5,MED)",
            "address_id": "ADDRESS_ID_6",
            "service_name": "Laundry",
            "original_service_name": "Laundry",
            "service_category_id": 14,
            "service_category": "laundry",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/laundry.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/laundry_map.svg",
            "start_time": "13:00",
            "timezone": "ADDRESS_TZ_6",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91014,
              "start_date_no_earlier_than": "DATE(5,SLASH)",
              "start_time_no_earlier_than": "1:00pm",
              "end_date_no_later_than": "DATE(5,SLASH)",
              "end_time_no_later_than": "3:00pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92014,
                "homekeeper": {
                  "id": 94001,
                  "name": "Maria Lopez"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93005,
            "address_id": "ADDRESS_ID_6",
            "check_in_date": "DATE(1,MED)",
            "check_out_date": "DATE(5,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_6",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMZN51VK9C",
              "guest": {
                "first_name": "Anna",
                "profile_picture": "https://randomuser.me/api/portraits/women/65.jpg",
                "last_name": "Kowalski"
              }
            }
          },
          {
            "id": 93008,
            "address_id": "ADDRESS_ID_1",
            "check_in_date": "DATE(5,MED)",
            "check_out_date": "DATE(8,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_1",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 3,
            "total_children": 1,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 3,
              "total_children": 1
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMTC68WQ1D",
              "guest": {
                "first_name": "David",
                "profile_picture": "https://randomuser.me/api/portraits/men/45.jpg",
                "last_name": "Park"
              }
            }
          },
          {
            "id": 93009,
            "address_id": "ADDRESS_ID_7",
            "check_in_date": "DATE(5,MED)",
            "check_out_date": "DATE(9,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_7",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Booking.com",
              "code": "BK31958472",
              "guest": {
                "first_name": "Olivia",
                "profile_picture": "https://randomuser.me/api/portraits/women/12.jpg",
                "last_name": "Brown"
              }
            }
          },
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93007,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(4,MED)",
            "check_out_date": "DATE(7,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR5193804",
              "guest": {
                "first_name": "Rachel",
                "profile_picture": "https://randomuser.me/api/portraits/women/79.jpg",
                "last_name": "Kim"
              }
            }
          }
        ],
        "inquiries": [],
        "availability_requests": []
      },
      {
        "date": "DATE(6,MED)",
        "jobs": [
          {
            "id": 90015,
            "date": "DATE(6,MED)",
            "address_id": "ADDRESS_ID_2",
            "service_name": "4 hour cleaning",
            "original_service_name": "4 hour cleaning",
            "service_category_id": 1,
            "service_category": "regular_cleaning",
            "service_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg",
            "service_map_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning_map.svg",
            "start_time": "11:30",
            "timezone": "ADDRESS_TZ_2",
            "is_private": true,
            "job_progress": "scheduled",
            "chat_rooms_with_unread_messages": [],
            "is_job_request": false,
            "booking": {
              "id": 91015,
              "start_date_no_earlier_than": "DATE(6,SLASH)",
              "start_time_no_earlier_than": "11:30am",
              "end_date_no_later_than": "DATE(6,SLASH)",
              "end_time_no_later_than": "3:30pm"
            },
            "homekeeper_jobs": [
              {
                "id": 92015,
                "homekeeper": {
                  "id": 94002,
                  "name": "Blueline Enterprises"
                }
              }
            ]
          }
        ],
        "reservations": [
          {
            "id": 93002,
            "is_tentative": true,
            "address_id": "ADDRESS_ID_2",
            "check_in_date": "DATE(0,MED)",
            "check_out_date": "DATE(6,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_2",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 4,
            "total_children": 2,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 4,
              "total_children": 2
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR4827163",
              "guest": {
                "first_name": "Mark",
                "profile_picture": "https://randomuser.me/api/portraits/men/32.jpg",
                "last_name": "Davis"
              }
            }
          },
          {
            "id": 93010,
            "address_id": "ADDRESS_ID_10",
            "check_in_date": "DATE(6,MED)",
            "check_out_date": "DATE(10,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "check_in",
            "timezone": "ADDRESS_TZ_10",
            "total_pets": 0,
            "total_adults": 6,
            "total_guests": 6,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 6,
              "total_guests": 6,
              "total_children": 0
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR6204917",
              "guest": {
                "first_name": "Tyler",
                "profile_picture": "https://randomuser.me/api/portraits/men/22.jpg",
                "last_name": "Johnson"
              }
            }
          },
          {
            "id": 93007,
            "address_id": "ADDRESS_ID_9",
            "check_in_date": "DATE(4,MED)",
            "check_out_date": "DATE(7,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_9",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Vrbo",
              "code": "VR5193804",
              "guest": {
                "first_name": "Rachel",
                "profile_picture": "https://randomuser.me/api/portraits/women/79.jpg",
                "last_name": "Kim"
              }
            }
          },
          {
            "id": 93008,
            "address_id": "ADDRESS_ID_1",
            "check_in_date": "DATE(5,MED)",
            "check_out_date": "DATE(8,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_1",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 3,
            "total_children": 1,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 3,
              "total_children": 1
            },
            "source_data": {
              "platform": "Airbnb",
              "code": "HMTC68WQ1D",
              "guest": {
                "first_name": "David",
                "profile_picture": "https://randomuser.me/api/portraits/men/45.jpg",
                "last_name": "Park"
              }
            }
          },
          {
            "id": 93009,
            "address_id": "ADDRESS_ID_7",
            "check_in_date": "DATE(5,MED)",
            "check_out_date": "DATE(9,MED)",
            "check_in_time": "16:00",
            "check_out_time": "11:00",
            "origin_check_in_check_out_time": "automatic_booking_setting",
            "reservation_status": "stay",
            "timezone": "ADDRESS_TZ_7",
            "total_pets": 0,
            "total_adults": 2,
            "total_guests": 2,
            "total_children": 0,
            "details": {
              "total_pets": 0,
              "total_adults": 2,
              "total_guests": 2,
              "total_children": 0
            },
            "source_data": {
              "platform": "Booking.com",
              "code": "BK31958472",
              "guest": {
                "first_name": "Olivia",
                "profile_picture": "https://randomuser.me/api/portraits/women/12.jpg",
                "last_name": "Brown"
              }
            }
          }
        ],
        "inquiries": [
          {
            "id": 96002,
            "uuid": "demo-inquiry-96002",
            "address_id": "ADDRESS_ID_3",
            "status": "pending",
            "check_in_date": "DATE(3,MED)",
            "check_out_date": "DATE(6,MED)",
            "reservation_status": "check_out",
            "timezone": "ADDRESS_TZ_3",
            "guest_name": "Priya Shah",
            "total_adults": 2,
            "total_children": 0,
            "total_infants": 0,
            "total_pets": 0,
            "total_guests": 2,
            "source_type_name": "Airbnb",
            "source_logo_url": "https://retool-uploads.s3.us-west-2.amazonaws.com/integrations/Airbnblogo.svg",
            "nights": 3,
            "currency": "USD",
            "amount": 65669,
            "source_data": {
              "platform": "Airbnb",
              "guest": {
                "first_name": "Priya",
                "last_name": "Shah",
                "profile_picture": "https://randomuser.me/api/portraits/women/26.jpg"
              }
            }
          }
        ],
        "availability_requests": []
      }
    ]
  }
}
